<i [className]="icon"></i>
<p>{{ message }}</p>
